// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAEy5lldF4u5sJmA8Hx5HOHbobaELRB6Ss",
  authDomain: "grassroots-care.firebaseapp.com",
  projectId: "grassroots-care",
  storageBucket: "grassroots-care.firebasestorage.app",
  messagingSenderId: "962490276147",
  appId: "1:962490276147:web:47ed1cbb5c58824cf64646",
  measurementId: "G-59JCMGMFXH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, auth, db, analytics, storage };
